export async function verifyGoogleToken({ token, isCaptchaComplete }: { token: string; isCaptchaComplete: boolean }) {
  try {
    if (window.location.href.includes("localhost")) return true;
    const validation = await fetch("/api/verifyGoogleToken", {
      method: "POST",
      body: JSON.stringify({ token })
    });

    if (!validation.ok) return false;

    const result = await validation.json();
    if (!isCaptchaComplete && !result.validationResult) {
      return false;
    }

    return true;
  } catch (err) {
    return false;
  }
}
